// extracted by mini-css-extract-plugin
module.exports = {"uikit-context-block":"uikit-context-block__2WzDn","uikit-context-block__item":"uikit-context-block__item__3dfvB"};